/* eslint-disable max-len */
import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import { withRouter, useLocation, useHistory } from 'react-router-dom';
import _ from 'lodash';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { Icon, InfoLabel, Tooltip, DateRangeField, useModal } from '@jutro/components';
import { useCookies } from 'react-cookie';
import { AccountBillingDetailsService } from 'gw-capability-billing';
import { UsersProfileDetailsService } from 'gw-capability-profileinfo';
import { PolicyService } from 'gw-capability-policy';
import { ClaimService } from 'gw-capability-claim';
import { Decimal } from 'decimal.js-light';
import { AMPSubmissionDraftService } from 'gw-capability-quoteandbind';
import { WMICModal } from 'gw-capability-policy-react';
import { DocumentService } from 'gw-capability-policydocument';
import { LOBConstants } from 'wmic-portals-utils-js';
import {
    WMICLoader,
    Currency as CurrencyField
} from 'gw-components-platform-react';
import {
    WMICClaimSummaryBoxAMP,
    WMICPolicySummaryBoxAMP,
    WMICLandingPagePaymentStatusModal,
    WMICOverduePolicies,
    WMICPaymentModal,
    WMICAddPolicyModal,
    WMICLink,
    WMICEditContactModal,
    WMICRcn
} from 'wmic-components-amp-common-react';
import {
    WMICNoticesComponent
} from 'gw-capability-policy-common-react';
import { useMediaQuery } from 'react-responsive';
import { getNormalizedLOBName, isCapabilityEnabled } from '@xengage/gw-portals-config-js';
import { useAuthentication } from 'wmic-digital-auth-react';
import {
    LobIconUtil,
    LocalDateUtil,
    WMICTooltipCookieUtil,
    WMICFeatureFlagUtil,
    CONSTANTS,
    WMICPaymentUtil,
    WMICBillingUtil,
    WMICRichTextUtil,
    WMICAmpUtil, WMICRemoteLogger, WMICTopics
} from 'wmic-portals-utils-js';
import { generateURL } from 'wmic-portals-url-js';
import { useTranslator } from '@jutro/locale';

// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
// import getClaimSummariesMockData from '../../overrides/mockdata/ClaimService/getClaimSummaries.json';
import { WMICReviewContactInfo } from 'wmic-components-capability-common-react';
import metadata from './LandingPage.metadata.json5';
import messages from './LandingPage.messages';
import styles from './LandingPage.module.scss';
import { publish } from "@jutro/events";

import { Button } from '@jutro/legacy/components';

const POLICY_STATUS = {
    IN_FORCE: 'In Force',
    EXPIRED: 'Expired',
    CANCELED: 'Canceled',
    CANCELED_FLAT: 'Canceled Flat',
    SCHEDULED: 'Scheduled'
};

const getCellType = (rowData) => {
    const activePeriod = _.first(rowData.periods);
    const lineOfBusiness = activePeriod.lines.length > 1
        ? activePeriod.lines.map((line) => line) : _.first(activePeriod.lines);
    const icon = activePeriod.lines.length > 1 ? 'mi-unarchive' : LobIconUtil.getMaterialIcon(lineOfBusiness);
    return <Icon icon={icon} title={lineOfBusiness} key={lineOfBusiness} />;
};

const isPolicyActive = (periods) => {
    const currentRenewed = periods.length > 1;
    const activePeriod = _.first(periods);
    return new Date(activePeriod.effective).getTime() < new Date().getTime() && !currentRenewed;
};

const shouldRenewalNotificationShow = (accountPolicyData) => {
    return accountPolicyData.some((policy) => policy.periods.length > 1);
};

const getCellStatus = (rowData) => {
    if (isPolicyActive(rowData.periods)) {
        return <InfoLabel type="success" size="medium" message={messages.statusActive} />;
    }

    return <InfoLabel type="info" size="medium" message={messages.statusRenewed} />;
};

const getCellPolicy = (rowData) => {
    const activePeriod = _.first(rowData.periods);
    const periodWithIDCard = rowData.periods.find((policy) => policy.idCardPublicID);
    return (
        <WMICLink
            className={styles.link}
            to={{
                pathname: `/account-policy-details/${activePeriod.policyId}`,
                productCode: activePeriod.lines[0],
                idCard: periodWithIDCard ? {
                    idCardSessionID: _.get(periodWithIDCard, 'idCardSessionID'),
                    idCardPublicID: _.get(periodWithIDCard, 'idCardPublicID')
                } : null
            }}
        >
            {activePeriod.policyId}
        </WMICLink>
    );
};

const getCellEffective = (rowData, rowIndex) => {
    const activePeriod = _.first(rowData.periods);
    const effectiveDate = new Date(activePeriod.effective);
    const expirationDate = new Date(activePeriod.expiration);
    const periodValue = {
        startDate: {
            year: effectiveDate.getFullYear(),
            month: effectiveDate.getMonth(),
            day: effectiveDate.getDate()
        },
        endDate: {
            year: expirationDate.getFullYear(),
            month: expirationDate.getMonth(),
            day: expirationDate.getDate()
        },
    }
    return (
        <DateRangeField
            id={`effectiveDate_${rowIndex}`}
            value={periodValue}
            hideLabel
            readOnly
        />
    );
};

const getCellClaim = (rowData) => {
    const activePeriod = _.first(rowData.periods);

    const redirectPath = {
        pathname: '/fnol-select-policy',
        state: {
            policyNumber: activePeriod.policyId,
            redirectPath: '/home',
            claimData: { lossDate: new Date() }
        }
    };
    return (
        <WMICLink to={redirectPath} className={styles.link}>
            {messages.fileClaim}
        </WMICLink>
    );
};

const getCellPremium = (rowData, rowIndex) => {
    const activePeriod = _.first(rowData.periods);
    return (
        <CurrencyField
            id={`premium_${rowIndex}`}
            value={activePeriod.premium}
            dataType="object"
            readOnly
            hideLabel
        />
    );
};

const mailToTrigger = (event, email) => {
    event.preventDefault();
    window.location = `mailto:${email}`;
};

const getAccountClaimsWMIC = (anAccountClaimData, state) => {
    if (anAccountClaimData && anAccountClaimData.items) {
        return anAccountClaimData.items.filter((c) => c.claimState === state);
    }
    return [];
};

const EMPTY_LOSS_LOCATION = { displayName: '', city: '', state: '', postalCode: '', country: '' };

const normalizeClaimSummaryItem = (item) => {
    const { lossDate, addresses = [] } = item;

    const normalizedLossDate = lossDate && typeof lossDate === 'object'
        ? new Date(lossDate.year, lossDate.month, lossDate.day).toISOString()
        : lossDate;

    const lossLocation_WMIC = item.lossLocation_WMIC !== undefined
        ? item.lossLocation_WMIC
        : (addresses[0] || EMPTY_LOSS_LOCATION);

    const lobs_WMIC = item.lobs_WMIC !== undefined
        ? item.lobs_WMIC
        : { personalAuto: { vehicleIncidents: [] } };

    return {
        ...item,
        lossDate: normalizedLossDate,
        lossLocation_WMIC,
        lobs_WMIC,
        completedDate_WMIC: item.completedDate_WMIC ?? item.closeDate
    };
};

const isInactivePolicy = (displayStatusWMIC) => {
    return displayStatusWMIC === POLICY_STATUS.CANCELED || displayStatusWMIC === POLICY_STATUS.EXPIRED || displayStatusWMIC === POLICY_STATUS.CANCELED_FLAT;
};

const populateOverduePolicyData = (policyInfo, billingData) => {
    return {
        id: policyInfo.policyId,
        details: {
            overdueAmount: billingData.amountOverDue.amount,
            currency: billingData.amountOverDue.currency,
            effective: policyInfo.effective,
            isInactive: isInactivePolicy(policyInfo.displayStatus_WMIC),
            isPendingCancellation: billingData.isNOITCCompleted,
            policyType: policyInfo.overview,
            billingData: WMICBillingUtil.populateDelinquencyInfo(billingData),
            policyData: policyInfo
        }
    };
};

const loadOverduePoliciesNotShown = () => {
    const savedOverduePoliciesNotShown = JSON.parse(localStorage.getItem('overduePoliciesNotShown'));
    if (savedOverduePoliciesNotShown === null) {
        return true;
    }
    return false;
};

function LandingPage() {
    const modalApi = useModal();
    const savedreviewContactInfoContainerNotShown = JSON.parse(
        localStorage.getItem('reviewContactInfoContainerNotShown')
    );
    const loadReviewContactInfoContainerNotShown = () => {
        if (savedreviewContactInfoContainerNotShown === null) {
            return true;
        }
        return false;
    };

    const savedRCNContainerNotShown = JSON.parse(
        localStorage.getItem('rcnContainerNotShown')
    );
    const loadRCNContainerNotShown = () => {
        if (savedRCNContainerNotShown === null) {
            return true;
        }
        return false;
    };

    const translator = useTranslator();
    const [accountBillingData, setAccountBillingData] = useState([]);
    const [accountPolicyData, setAccountPolicyData] = useState([]);
    const [accountClaimData, setAccountClaimData] = useState([]);
    const { authHeader, userInfo: authUserData } = useAuthentication();
    const [accountData, setAccountData] = useState([]);
    const [accountContact, setAccountContact] = useState([]);
    const [isLoading, setLoadingState] = useState(false);
    const { capabilitiesConfig, ctaSettings } = appConfig;
    const [hasNotification, setHasNotification] = useState(false);
    const [isListBillAvailable, setIsListBillAvailable] = useState(false);
    const [areClaimsAvailable, setAreClaimsAvailable] = useState(false);
    const [isCtaAvailable, setIsCtaAvailable] = useState(false);
    const [timeTravelOffsetDaysData, setTimeTravelOffsetDaysData] = useState(undefined);
    const [notices, setNotices] = useState([]);
    const [arePeriodicUpdates, setArePeriodicUpdates] = useState(false);
    const [addedPolicies, updateAddedPolicies] = useState([]);
    const [showWeAreSorry, setShowWeAreSorry] = useState(false);
    const [finishedInit, setFinishedInit] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [showOverduePoliciesModal, setShowOverduePoliciesModal] = useState(false);
    const [distributionType, updateDistributionType] = useState('');
    const [ldFlags, setLdFlags] = useState({});
    const [ctaPeriodicUpdatesFeatureFlag, setCtaPeriodicUpdatesFeatureFlag] = useState({});
    const [isRCNAvailable, setIsRCNAvailable] = useState(false);
    const [hideRcnCta, setHideRcnCta] = useState(undefined);
    const [isCeaPolicyAvailable, setIsCeaPolicyAvailable] = useState(false);

    // check if Review your contact informaion modal has been interacted with a user
    // and the contact information is confirnmed or changed by the user.
    const [isContactReviewed, setIsContactReviewed] = useState(
        savedreviewContactInfoContainerNotShown !== null &&
            savedreviewContactInfoContainerNotShown === true
    );

    const isMobile = useMediaQuery({ maxWidth: 767 });
    const { search, pathname } = useLocation();
    const history = useHistory();
    const CLAIM_STATE = {
        OPEN: 'open',
        CLOSED: 'closed'
    };
    const currentDate = new Date();
    const featureFlags = WMICFeatureFlagUtil.getFeatureFlags();

    const logger = WMICRemoteLogger.getWMICRemoteLogger(
        'LandingPage',
        history.location.pathname,
        window.location,
        ldFlags,
        authHeader
    );

    const logPcCall = (methodName, phase, data) => {
        try {
            let safeData;
            if (data instanceof Error) {
                safeData = data.message;
            } else if (typeof data === 'object' && data !== null) {
                const json = JSON.stringify(data);
                safeData = json === '{}' ? 'no params' : json;
            } else {
                safeData = String(data ?? '');
            }
            const userEmail = authUserData?.email || authUserData?.user_id || 'unknown';
            const sessionId = sessionStorage.getItem('X_GWRE_SESSION') || 'no-session';
            logger.sendLogToPC({
                level: data instanceof Error ? 'error' : 'info',
                logCategory: 'log',
                message: `[LandingPage][PC-CALL][${userEmail}][${sessionId}] ${methodName} ${phase}: ${safeData}`,
                userId: authUserData?.user_id,
                pageName: 'LandingPage',
                pageUrl: window.location?.pathname,
                ts: new Date().toISOString()
            }, authHeader);
        } catch (_) { /* never let logging break page load */ }
    };

    const triggerLoginSuccessAnalytics = useCallback(() => {
        const hasAuthSession = Boolean(authHeader?.Authorization);
        const sessionId = sessionStorage.getItem('X_GWRE_SESSION') || '';

        if (pathname !== '/home' || !hasAuthSession || !sessionId) {
            return;
        }

        const trackingKey = `amp-login-success-tracked:${sessionId}`;
        if (sessionStorage.getItem(trackingKey) === 'true') {
            return;
        }

        const landingState = (
            _.get(authUserData, 'state')
            || _.get(authUserData, 'address.state')
            || _.get(window, 'wins_data_layer.state')
            || ''
        ).toString().toLowerCase();

        publish(WMICTopics.ROUTE_CHANGED, {
            channel: 'my account',
            page: 'my account:login:success',
            subchannel1: 'login',
            subchannel2: 'login',
            sessionid: sessionId,
            state: landingState
        });

        sessionStorage.setItem(trackingKey, 'true');
    }, [pathname, authHeader, authUserData]);

    const hasANotification = (notice) => {
        const tempNotices = notices;
        tempNotices.push(notice);
        setHasNotification(true);
        setNotices(tempNotices);
    };

    const [cookies, setCookie] = useCookies([]);

    const reloadlandingPage = () => {
        history.push('/home');
    };

    const managePaymentStatusModal = () => {
        const queryStrings = new URLSearchParams(search);
        const paramsEncoded = queryStrings.get('params');
        if (paramsEncoded) {
            const params = Buffer.from(paramsEncoded, 'base64').toString('ascii');
            const queryStringsNested = new URLSearchParams(params);
            const paymentStatus = queryStringsNested.get('paymentstatus');
            const invoiceStreamId = queryStringsNested.get('entity');
            if (paymentStatus && invoiceStreamId && (paymentStatus === CONSTANTS.INTEGRATION_CC_PAYMENT_STATUS.COMPLETE || paymentStatus === CONSTANTS.INTEGRATION_CC_PAYMENT_STATUS.ERROR)) {
                modalApi.showModal(<WMICLandingPagePaymentStatusModal
                    paymentStatus={paymentStatus}
                    invoiceStreamId={invoiceStreamId}
                    onClose={reloadlandingPage}
                />);
            }
        }
    };

    const initArePeriodicUpdates = async () => {
        const periodicUpdateParamsDTO_WMIC = {
            UseAddress: true
        };
        logPcCall('getPeriodicUpdates', 'INPUT', { params: periodicUpdateParamsDTO_WMIC });
        try {
            const periodicUpdates = await PolicyService.getPeriodicUpdates(periodicUpdateParamsDTO_WMIC, authHeader);
            logPcCall('getPeriodicUpdates', 'OUTPUT', { itemCount: periodicUpdates?.items?.length ?? 0 });
            if (periodicUpdates.items.length > 0) {
                setArePeriodicUpdates(true);
            }
        } catch (e) {
            logPcCall('getPeriodicUpdates', 'ERROR', e);
        }
    };

    const fetchBillingData = () => {
        setLoadingState(true);
        let billingPromise = Promise.resolve([]);
        let claimPromise = Promise.resolve([]);
        if (isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'billing' })) {
            logPcCall('getPolicyPaymentSummary_WMIC', 'INPUT', {});
            billingPromise = AccountBillingDetailsService.getPolicyPaymentSummary_WMIC(authHeader)
                .then((res) => { logPcCall('getPolicyPaymentSummary_WMIC', 'OUTPUT', { billingCount: Array.isArray(res) ? res.length : (res?.activeInvoices?.length ?? 0) }); return res; })
                .catch((e) => { logPcCall('getPolicyPaymentSummary_WMIC', 'ERROR', e); return []; });
        }
        // if (isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'claim' }) && claimAvailability.isAvailable) {
        if (isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'claim' }) && areClaimsAvailable) {
            logPcCall('getClaimSummaries', 'INPUT', { claimStates: ['open', 'closed'] });
            claimPromise = ClaimService.getClaimSummaries({ claimStates: ['open', 'closed'] }, {}, authHeader)
                .then((res) => { logPcCall('getClaimSummaries', 'OUTPUT', { claimCount: res?.items?.length ?? 0 }); return res; })
                .catch((e) => { logPcCall('getClaimSummaries', 'ERROR', e); return {}; });
        }
        initArePeriodicUpdates();
        logPcCall('getAccountPolicySummaries_WMIC', 'INPUT', {});
        logPcCall('getAccountsContactSummaries', 'INPUT', {});
        Promise.all([billingPromise.then(setAccountBillingData),
            PolicyService.getAccountPolicySummaries_WMIC(authHeader, authUserData.firstName, authUserData.lastName).then((res) => {
                logPcCall('getAccountPolicySummaries_WMIC', 'OUTPUT', {
                    policyCount: Array.isArray(res) ? res.length : 0,
                    policyIds: Array.isArray(res) ? res.map((p) => p?.periods?.[0]?.policyId) : []
                });
                setAccountPolicyData(res);
            }).catch((e) => logPcCall('getAccountPolicySummaries_WMIC', 'ERROR', e)),
            UsersProfileDetailsService.getAccountsContactSummaries(authHeader).then((res) => {
                logPcCall('getAccountsContactSummaries', 'OUTPUT', { accountCount: Array.isArray(res) ? res.length : 0 });
                setAccountData(res);
            }).catch((e) => logPcCall('getAccountsContactSummaries', 'ERROR', e)),
            claimPromise
                .then((res) => {
                    if (Array.isArray(res.items) && res.items.length) {
                        const filteredClaims = res.items.filter((item) => !item.claimNumber.startsWith('9'));
                        res.items = filteredClaims.map((item) => normalizeClaimSummaryItem(item));
                    }
                    setAccountClaimData(res);
                    if (!_.isEmpty(res)) {
                        publish('CLAIM_TRACKING', {name: 'ClaimEvent', action: 'List Claims', label: `Has Claims (${res.items.length})`});
                    }
                })
        ]).finally(() => {
            setLoadingState(false);
        });
    };

    const initFeatureFlags = async () => {
        const hasAuthHeader = Boolean(authHeader?.Authorization);
        const authDebugSummary = {
            hasAuthHeader,
            hasUserId: Boolean(authUserData?.user_id),
            hasEmail: Boolean(authUserData?.email),
            grantedAuthoritiesCount: authUserData?.grantedAuthorities?.length || 0
        };
        try {
            const rFlags = await WMICFeatureFlagUtil.useFlags({
                authHeader,
                authUserData
            });
            const flagKeys = Object.keys(rFlags || {});
            setLdFlags(rFlags || {});
        } catch (error) {
            setLdFlags({});
        }
    }

    const initContact = async () => {
        logPcCall('getAccountContact', 'INPUT', { userId: authUserData?.user_id });
        try {
            const contactResult = await WMICAmpUtil.getAccountContact(authHeader, authUserData);
            logPcCall('getAccountContact', 'OUTPUT', {
                found: Boolean(contactResult),
                distributionType: contactResult ? _.get(contactResult, 'prefDistributionMethod_WMIC', '') : null
            });
            if (contactResult) {
                setAccountContact(contactResult.accountContact);
                updateDistributionType(_.get(contactResult, 'prefDistributionMethod_WMIC', ''));
            }
        } catch (e) {
            logPcCall('getAccountContact', 'ERROR', e);
        }

        // eslint-disable-next-line react-hooks/rules-of-hooks
        const rFlags = await WMICFeatureFlagUtil.useFlags(authUserData);
        setLdFlags(rFlags);
    }

    const dashboardConsentFeatureFlagAvailability = useCallback(() => {
        return WMICFeatureFlagUtil.queryAvailabilityAMP(ldFlags, featureFlags.DASHBOARDCONSENT);
    }, [featureFlags, ldFlags]);

    const onSetCookies = useCallback(
        (params) => {
            setCookie(params);
        }, [setCookie]
    );

    useEffect(() => {
        const ampAvailability = WMICFeatureFlagUtil.queryAvailabilityAMP(ldFlags, featureFlags.AMP);
        const ampNotice = WMICFeatureFlagUtil.getAMPAvailabilityInfo(ampAvailability, currentDate, translator);
        const claimAvailability = WMICFeatureFlagUtil.queryAvailabilityAMP(ldFlags, featureFlags.CLAIMS);
        const claimNotice = WMICFeatureFlagUtil.getClaimsAvailabilityInfo(claimAvailability, currentDate, translator);
        const paymentAvailability = WMICFeatureFlagUtil.queryAvailabilityAMP(ldFlags, featureFlags.PAYMENTS);
        const paymentNotice = WMICFeatureFlagUtil.getPaymentsAvailabilityInfo(paymentAvailability, currentDate, translator);
        const listBillAvailable = WMICFeatureFlagUtil.queryAvailabilityAMP(ldFlags, featureFlags.CTA_LISTBILL);
        const ctaAvailable = WMICFeatureFlagUtil.queryAvailabilityAMP(ldFlags, featureFlags.CTA);
        const timeTravelOffsetDays = WMICFeatureFlagUtil.queryAvailabilityAMP(ldFlags, featureFlags.TEST_DATA);
        const ctaPeriodicUpdates = WMICFeatureFlagUtil.queryAvailabilityAMP(ldFlags, featureFlags.CTA_PERIODIC_UPDATES);
        const ctaRCN = WMICFeatureFlagUtil.queryAvailabilityAMP(ldFlags, featureFlags.CTA_RCN);
        const ceaPolicyAvailable = WMICFeatureFlagUtil.queryAvailabilityAMP(ldFlags, featureFlags.CEAPOLICY);

        if (Object.entries(ldFlags).length > 1 && ampAvailability && ampAvailability.isAvailable === false) {
            setShowWeAreSorry(true);
        }
        setIsListBillAvailable(listBillAvailable?.isAvailable);
        const isClaimsUrlConfigured = Boolean(
            appConfig.serviceUrls?.claimsEndpoint && !appConfig.serviceUrls.claimsEndpoint.includes('{{')
        );
        setAreClaimsAvailable(claimAvailability?.isAvailable && isClaimsUrlConfigured);
        setIsCtaAvailable(ctaAvailable?.isAvailable);
        setIsRCNAvailable(ctaRCN?.isAvailable);
        setTimeTravelOffsetDaysData(timeTravelOffsetDays);
        setCtaPeriodicUpdatesFeatureFlag(ctaPeriodicUpdates?.isAvailable);
        setIsCeaPolicyAvailable(ceaPolicyAvailable?.isAvailable);

        if (ampNotice && ampNotice.body) {
            hasANotification(ampNotice);
        }
        if (claimNotice && claimNotice.body) {
            hasANotification(claimNotice);
        }
        if (paymentNotice && paymentNotice.body) {
            hasANotification(paymentNotice);
        }
    }, [ldFlags]);

    useEffect(() => {
        if (showWeAreSorry) {
            history.push('technicalErrorPage/maintenance');
        }
    }, [showWeAreSorry]);

    useEffect(() => {
        triggerLoginSuccessAnalytics();
        initFeatureFlags();
        initContact();
        fetchBillingData();
        managePaymentStatusModal();
        setFinishedInit(true);
        // disable re render
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const homePageAnalyticsFiredRef = useRef(false);

    useEffect(() => {
        // Wait until loading settles so we know whether the Review Contact Info modal will auto-appear.
        if (homePageAnalyticsFiredRef.current || isLoading) {
            return;
        }

        homePageAnalyticsFiredRef.current = true;

        const willReviewContactInfoModalAppear = isCtaAvailable
            && arePeriodicUpdates
            && ctaPeriodicUpdatesFeatureFlag
            && !isContactReviewed
            && loadReviewContactInfoContainerNotShown();

        if (!willReviewContactInfoModalAppear) {
            publish(WMICTopics.ROUTE_CHANGED, {
                channel: 'my account',
                page: 'my account:manage my account:home',
                subchannel1: 'manage my account',
                sessionid: sessionStorage.getItem('X_GWRE_SESSION') || '',
                state: (window.wins_data_layer?.state || '').toString().toLowerCase(),
                route_view_mode: 'back_only'
            });
        }
    }, [isLoading, isCtaAvailable, arePeriodicUpdates, ctaPeriodicUpdatesFeatureFlag, isContactReviewed]);

    useEffect(() => {
        // accountPolicyData and accountBillingData are already in state from fetchBillingData.
        // Only check consent — no need to re-fetch summaries here.
        if (finishedInit && !WMICTooltipCookieUtil.hasShowConsentCookie(authUserData, cookies)
            && dashboardConsentFeatureFlagAvailability().isAvailable) {
            PolicyService.isEdocsReconsentRequired(authHeader).then((consentRequired) => {
                if (consentRequired) {
                    WMICTooltipCookieUtil.setShowConsentCookie(authUserData, onSetCookies);
                    const email = accountContact.emailAddress1;
                    modalApi.showModal(
                        <WMICEditContactModal
                            email={email}
                            updateRefresh={setRefresh}
                            refresh={refresh}
                            distributionType={distributionType}
                            updateDistributionType={updateDistributionType}
                        />
                    );
                }
            });
        };
    }, [finishedInit, ldFlags, accountContact]);

    useEffect(() => {
        if (!_.isEmpty(addedPolicies)) {
            fetchBillingData();
            updateAddedPolicies([]);
        }
    }, [addedPolicies]);

    // Fetch claims once the feature flag resolves to true.
    // Avoids a full re-fetch of policies and billing (which don't depend on this flag).
    useEffect(() => {
        if (areClaimsAvailable) {
            ClaimService.getClaimSummaries({ claimStates: ['open', 'closed'] }, {}, authHeader)
                .then((res) => {
                    if (Array.isArray(res.items) && res.items.length) {
                        const filteredClaims = res.items.filter((item) => !item.claimNumber.startsWith('9'));
                        res.items = filteredClaims.map((item) => normalizeClaimSummaryItem(item));
                    }
                    setAccountClaimData(res);
                    if (!_.isEmpty(res)) {
                        publish('CLAIM_TRACKING', { name: 'ClaimEvent', action: 'List Claims', label: `Has Claims (${res.items.length})` });
                    }
                });
        }
    }, [areClaimsAvailable])

    const aggregateBilling = useCallback((invoices) => {
        if (invoices.length === 0) {
            return null;
        }

        let total = 0;
        let due = new Date(invoices[0].dueDate);

        _.each(invoices, (invoice) => {
            total += invoice.amountDue.amount;
            const newDue = new Date(invoice.dueDate);
            if (newDue.getTime() < due.getTime()) {
                due = newDue;
            }
        });

        return {
            amountDue: {
                amount: total,
                currency: invoices[0].amountDue.currency
            },
            earliestDue: due
        };
    }, []);

    const getMyBalanceOverDueAndCurrentData = useCallback(
        (invoiceStatus) => {
            if (accountBillingData && accountBillingData.activeInvoices) {
                const invoices = accountBillingData.activeInvoices;
                return aggregateBilling(
                    invoices.filter((invoice) => invoice.invoiceStatus === invoiceStatus)
                );
            }
            return null;
        },
        [accountBillingData, aggregateBilling]
    );

    const getBalanceData = useCallback(() => {
        const overdue = getMyBalanceOverDueAndCurrentData('due');
        const current = getMyBalanceOverDueAndCurrentData('billed');
        if (overdue && current) {
            return {
                amount: current.amountDue.amount + overdue.amountDue.amount,
                currency: current.amountDue.currency
            };
        }
        if (overdue || current) {
            return (overdue || current).amountDue;
        }
        return null;
    }, [getMyBalanceOverDueAndCurrentData]);

    const readValue = useCallback(
        (id, path) => {
            if (path === 'balanceAmount') {
                return getBalanceData();
            }
            if (path === 'overDueAmount') {
                return _.get(getMyBalanceOverDueAndCurrentData('due'), 'amountDue');
            }
            if (path === 'currentAmount') {
                return _.get(getMyBalanceOverDueAndCurrentData('billed'), 'amountDue');
            }
            if (path === 'dueDate') {
                return _.get(getMyBalanceOverDueAndCurrentData('due'), 'earliestDue');
            }
            return _.get(accountBillingData, path);
        },
        [accountBillingData, getBalanceData, getMyBalanceOverDueAndCurrentData]
    );

    const policyWithIDCard = useMemo(() => {
        let periodWithIDCard;
        accountPolicyData.some((policyData) => {
            return policyData.periods.some((period) => {
                if (period.idCardPublicID) {
                    periodWithIDCard = period;
                    return true;
                }
                return false;
            });
        });
        return periodWithIDCard;
    }, [accountPolicyData]);

    const getIDCardQuickLink = useMemo(() => {
        if (!policyWithIDCard) {
            return null;
        }
        return DocumentService.downloadPolicyDocument(
            policyWithIDCard.idCardPublicID,
            policyWithIDCard.idCardSessionID
        );
    }, [policyWithIDCard]);

    const automatedPaymentURL = useMemo(() => {
        const billingID = _.get(accountBillingData, 'manualPayPaymentGroups[0]');

        if (!billingID) {
            return undefined;
        }
        return `billing-summary/${billingID}`;
    }, [accountBillingData]);

    const firstAccountSummaryDefined = useMemo(() => {
        return accountData.length <= 1 && !_.isEmpty(accountData);
    }, [accountData]);

    const claimCapabilityCheck = useMemo(() => {
        return isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'fnol' });
    }, [capabilitiesConfig]);

    const getCellAgent = useCallback(
        (rowData) => {
            return (
                <>
                    <WMICLink className={styles.link} onClick={(e) => mailToTrigger(e, rowData.producerContact.email)} href="/">
                        {rowData.producerContact.displayName}
                    </WMICLink>
                    <br />
                    {rowData.producerContact.phoneNumber ? (
                        <span>
                            {translator(messages.policyDetailsTel)}
                            {rowData.producerContact.phoneNumber}
                        </span>
                    ) : (
                        ''
                    )}
                </>
            );
        },
        [translator]
    );

    const getTableOverrides = useCallback(() => {
        return {
            typeColumn: { renderCell: getCellType },
            statusColumn: { renderCell: getCellStatus },
            policyColumn: { renderCell: getCellPolicy },
            effectiveColumn: { renderCell: getCellEffective },
            premiumColumn: { renderCell: getCellPremium },
            fileAClaimColumn: {
                visible: claimCapabilityCheck,
                renderCell: getCellClaim
            },
            agentColumn: {
                visible: accountData.length > 1,
                renderCell: getCellAgent
            }
        };
    }, [accountData, getCellAgent, claimCapabilityCheck]);

    const onFileAClaimQuickLinkClick = useCallback(
        () => () => {
            return history.push({
                pathname: '/fnol-select-policy',
                state: {
                    redirectPath: '/home',
                    claimData: { lossDate: new Date() }
                }
            });
        },
        [history]
    );

    const onAddPolicyReminderTooltipClose = useCallback(
        (event) => {
            event.preventDefault();
            WMICTooltipCookieUtil.setAddPolicyReminderCookie(authUserData, onSetCookies);
        }, [authUserData, onSetCookies]
    );

    const showBillingSection = useMemo(() => {
        return isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'billing' });
    }, [capabilitiesConfig]);

    const paymentModal = (policyModalData) => {
        modalApi.showModal(<WMICPaymentModal fetchBillingData={fetchBillingData} data={policyModalData} isOpen isOpenFromOverdueContainer={true} ldFlags={ldFlags} />).catch(_.noop);
    };

    const addPolicyModal = () => {
        modalApi.showModal(<WMICAddPolicyModal data={{}} isOpen updateAddedPolicies={updateAddedPolicies} policies={{...accountPolicyData, ...accountBillingData}} />).catch(_.noop);
    };

    const closePaymentModal = () => {
        localStorage.setItem('overduePoliciesNotShown', JSON.stringify(false));
    };

    const closeContactInfoModal = () => {
        if(loadOverduePoliciesNotShown && isCtaAvailable) {
            setShowOverduePoliciesModal(true);
        }
    };

    const getPolicyDataForClaim = useCallback((policyNumber) => {
        const policy = accountPolicyData.find((accountPolicy) => policyNumber === accountPolicy.periods[0].policyId)
        return _.get(policy, 'periods[0].overview')
    }, [accountPolicyData])

    const getTooltipAndButtonWMIC = () => {
        return (
                <Button
                    aria-haspopup="true"
                    type="secondary"
                    className="ww-btn-secondary"
                    trackButtonIdentifier={translator(messages.addPolicyTrackButtonIdentifier)}
                    onClick={(event) => {
                        onAddPolicyReminderTooltipClose(event);
                        // "Add a Policy" CTA clicked on the Home page.
                        publish(WMICTopics.CTA_CLICK, {
                            channel: 'my account',
                            cta: 'my account:manage my account:home-add a policy',
                            page: 'my account:manage my account:home',
                            subchannel1: 'manage my account',
                            sessionid: sessionStorage.getItem('X_GWRE_SESSION') || '',
                            state: (window.wins_data_layer?.state || '').toString().toLowerCase()
                        });
                        addPolicyModal();
                    }}
                >
                    {translator(messages.addPolicy)}
                </Button>
        );
    };

    const getNotices = () => {
        return (
            <WMICNoticesComponent notices={notices} />
        );
    };

    const showCallToAction = (billingData, period) => {
        const hasOverdueAmount = (data) => {
            const overdue = new Decimal(data.amountOverDue ? data.amountOverDue.amount : 0);
            const priorTermBalance = new Decimal(data.priorTermBalance ? data.priorTermBalance.amount : 0);
            const totalOverdue = overdue.plus(priorTermBalance);
            return totalOverdue && new Decimal(totalOverdue).isPositive();
        };

        let renewalStatus;

        if (period.renewal_Details_WMIC && period.renewal_Details_WMIC.displayStatus_WMIC) {
            renewalStatus = period.renewal_Details_WMIC.displayStatus_WMIC;
        }

        let canShowPayNow = WMICPaymentUtil.canShowPayNowButton(billingData, WMICPaymentUtil.getPolicyStatusName(period.displayStatus_WMIC, renewalStatus));

        if (WMICPaymentUtil.isListBill(billingData)) {
            if (isListBillAvailable) {
                if (billingData.delinquencyInfo.hasOpenDelinquency) {
                    const currentTime = new Date();
                    // offset the currentTime so that we can test time travel scenarios
                    const timeTravelOffsetDays = timeTravelOffsetDaysData?.isAvailable ? timeTravelOffsetDaysData?.timeTravelOffsetDays : 0;
                    currentTime.setDate(currentTime.getDate() + timeTravelOffsetDays);

                    const startDateCTA = new Date(billingData.delinquencyInfo.startDate);
                    startDateCTA.setDate(startDateCTA.getDate() + ctaSettings.delayListBillDelinquencyDays);
                    canShowPayNow = currentTime > startDateCTA;
                } else {
                    canShowPayNow = billingData.isPolicyDelinquent;
                }
            } else {
                canShowPayNow = false;
            }
        }

        return canShowPayNow && hasOverdueAmount(billingData);
    };

    /* Modal version when maintenance */
    const getShowWeAreSorry = useCallback(() => {
        if(showWeAreSorry) {
            const body = WMICRichTextUtil.translateRichText(translator(messages.documentErrorMessage));
            const title = translator(messages.wereSorry);
            modalApi.showModal(
                <WMICModal
                    id="insuranceIDCardModal"
                    modalHeader={title}
                    modalBody={body}
                    onConfirmCallback={() => _.noop()}
                    confirmButtonText={translator(messages.closeButtonText)}
                />
            );
        }
    }, [showWeAreSorry]);

    const getAccountPoliciesAggregatedDataWMIC = (anAccountPolicyData, anAccountBillingData) => {
        const policiesAggregatedData = { activePolicies: [], inactivePolicies: [], overduePolicies: [] };
        if (anAccountPolicyData && anAccountBillingData) {
            anAccountPolicyData.forEach((policy) => {
                if (policy.periods.length > 0) {
                    let activePeriod = policy.periods[0];
                    if (activePeriod) {
                        if (isCeaPolicyAvailable === true && policy?.ceaCompanionPolicies?.length > 0) {
                            activePeriod.ceaCompanionPolicy = policy.ceaCompanionPolicies[0];
                        }
                        const billingInfo = anAccountBillingData.find((element) => element.policyId === activePeriod.policyId);
                        if (activePeriod && billingInfo) {
                            if (!isInactivePolicy(activePeriod.displayStatus_WMIC)) {
                                policiesAggregatedData.activePolicies.push({ policyData: activePeriod, billingData: billingInfo });
                            } else {
                                policiesAggregatedData.inactivePolicies.push({ policyData: activePeriod, billingData: billingInfo });
                            }
                            if (showCallToAction(billingInfo, activePeriod)) {
                                policiesAggregatedData.overduePolicies.push(populateOverduePolicyData(activePeriod, billingInfo));
                            }
                        }
                    }
                }
            });
        }
        return policiesAggregatedData;
    };

    const policies = useMemo(() => {
        return getAccountPoliciesAggregatedDataWMIC(accountPolicyData, accountBillingData);
    }, [accountPolicyData, accountBillingData]);

    const openClaims = useMemo(() => {
        return getAccountClaimsWMIC(accountClaimData, CLAIM_STATE.OPEN);
    }, [accountClaimData, CLAIM_STATE.OPEN]);

    const closedClaims = useMemo(() => {
        return getAccountClaimsWMIC(accountClaimData, CLAIM_STATE.CLOSED);
    }, [accountClaimData, CLAIM_STATE.CLOSED]);

    const iterableOverrides = useMemo(() => {
        const openClaimOverrides = openClaims.map((item, index) => {
            return {
                [`claimSummaryBox${index}`]: {
                    title: getPolicyDataForClaim(item.policyNumber)
                }
            };
        });

        const closedClaimOverrides = closedClaims.map((item, index) => {
            return {
                [`closedClaimSummaryBox${index}`]: {
                    title: getPolicyDataForClaim(item.policyNumber)
                }
            };
        });

        return Object.assign({}, ...openClaimOverrides, ...closedClaimOverrides);
    }, [openClaims, closedClaims, getPolicyDataForClaim]);


    const policyWithRCN = (policyData) => {
        let policyPeriodData = {};
        const rcnDocumentCode = CONSTANTS.DOCUMENT_TYPE.RCN;
        const rcnhDocumentCode = CONSTANTS.DOCUMENT_TYPE.RCNH;

        if(policyData) {
            policyData.forEach((policy) => {
                if (policy.periods.length > 0) {
                    policy.periods.forEach((period) => {
                        if(period.documents_WMIC.indexOf(rcnDocumentCode) !== -1 ||
                            period.documents_WMIC.indexOf(rcnhDocumentCode) !== -1){
                                policyPeriodData = {
                                    policyNumber: period.policyId,
                                    termNumber: period.termNumber_WMIC,
                                    lob: period.lines.includes(LOBConstants.PA_LINE) ? LOBConstants.PA_LINE : LOBConstants.PP_LINE
                                };
                        }
                    });
                }
            });
        }

        return policyPeriodData;
    }

    useEffect(() => {
        const policyPeriodData = policyWithRCN(accountPolicyData);
        const policyNumber = policyPeriodData?.policyNumber;
        if(policyNumber){
            const hideRcnCtaVar = WMICTooltipCookieUtil.hasDontShowAgainCookie(authUserData, cookies, policyNumber);
            setHideRcnCta(hideRcnCtaVar);
        }

    }, [accountPolicyData]);

    const getBillingDataForTerm = (billingData, policyNumber, termNumber) => {
        let billingDataToReturn;

        billingData.forEach((policyBillingData) => {
            if (policyBillingData.policyId === policyNumber) {
                if (policyBillingData.termNumber === termNumber) {
                    billingDataToReturn = policyBillingData;
                } else if (policyBillingData.renewalPaymentDetails?.termNumber === termNumber) {
                    billingDataToReturn = policyBillingData.renewalPaymentDetails;
                }
            }
        });

        return billingDataToReturn;
    }

    const showRcn = (policyData, billingData) => {
        let showRcnContainer = false;
        const rcnDocumentCode = CONSTANTS.DOCUMENT_TYPE.RCN;
        const rcnhDocumentCode = CONSTANTS.DOCUMENT_TYPE.RCNH;

        if (!_.isEmpty(policyData) && !_.isEmpty(billingData)) {
            policyData.forEach((policy) => {
                policy.periods.forEach((period) => {
                    const hasRCN = period.documents_WMIC.indexOf(rcnDocumentCode) !== -1;
                    const hasRCNH = period.documents_WMIC.indexOf(rcnhDocumentCode) !== -1;
                    const term = period.termNumber_WMIC;
                    const policyNumber = period.policyId;

                    if (hasRCN || hasRCNH) {
                        const billingDataForTerm = getBillingDataForTerm(billingData, policyNumber, term);

                        // offset the currentDate so that we can test time travel scenarios
                        const currentDate = new Date();
                        const timeTravelOffsetDays = timeTravelOffsetDaysData?.isAvailable ? timeTravelOffsetDaysData?.timeTravelOffsetDays : 0;
                        currentDate.setDate(currentDate.getDate() + timeTravelOffsetDays);
                        
                        //set currentDate time to midnight to compare with policy term effective date time
                        currentDate.setHours(0);
                        currentDate.setMinutes(0);
                        currentDate.setSeconds(0);
    
                        const policyTermEffectiveDate = new Date(period.effective);
                        const notificationExpiryDays = period.lines.includes(LOBConstants.PA_LINE) ? 30 : 29;
                        policyTermEffectiveDate.setDate(policyTermEffectiveDate.getDate() + notificationExpiryDays);

                        // check if any payment was made
                        if(billingDataForTerm && currentDate <= policyTermEffectiveDate) {
                            if ((billingDataForTerm.paymentPlan === "Full Pay" || billingDataForTerm.paymentPlan === "Two Pay") && billingDataForTerm.totalPremiumAmount.amount === billingDataForTerm.outstandingAmount.amount) {
                                showRcnContainer = true;
                            } else if (billingDataForTerm.paymentPlan === "Monthly Automated Recurring") {
                                showRcnContainer = true;
                            }
                        }
                    }
                })
            })
        }

        return showRcnContainer;
    }

    const showRcnMemo = useMemo(() => {
        return showRcn(accountPolicyData, accountBillingData);
    }, [accountPolicyData, accountBillingData]);

    const override = {
        ...iterableOverrides,
        '@field': {
            phone: {
                labelPosition: 'left'
            },
            fetchBillingData: fetchBillingData,
        },
        notificationContainer: {
            content: getNotices(),
            visible: hasNotification
        },
        wmicLoader: {
            visible: isLoading
        },
        pageHome: {
            visible: !isLoading
        },
        payNowButton: {
            visible: firstAccountSummaryDefined
        },
        mediaSidebar: {
            showContact: accountData.length > 1
        },
        policiesTable: {
            data: accountPolicyData
        },
        printAnIDCardLink: {
            visible: !_.isNil(policyWithIDCard),
            href: getIDCardQuickLink,
            target: '_blank'
        },
        setupAutomatedPaymentsLink: {
            to: automatedPaymentURL,
            visible: !!automatedPaymentURL && showBillingSection
        },
        renewalNotification: {
            visible: shouldRenewalNotificationShow(accountPolicyData)
        },
        fileAClaimLink: {
            onClick: onFileAClaimQuickLinkClick(),
            visible: claimCapabilityCheck
        },
        tileGroupContainer: {
            visible: showBillingSection
        },
        makeAPaymentLink: {
            visible: showBillingSection
        },
        tooltipAndButtonDiv: {
            content: getTooltipAndButtonWMIC()
        },
        overduePoliciesContainer: {
            visible: isCtaAvailable,
            openModalOnRender: loadOverduePoliciesNotShown(),
            openModal: showOverduePoliciesModal,
            policies: policies.overduePolicies,
            onPayPolicyClick: paymentModal,
            onClose: closePaymentModal
        },
        reviewContactInfoContainer: {
            openModalOnRender: loadReviewContactInfoContainerNotShown(),
            visible: isCtaAvailable && !isLoading && arePeriodicUpdates && ctaPeriodicUpdatesFeatureFlag && !isContactReviewed,
            onClose: closeContactInfoModal,
            updateIsContactReviewed: setIsContactReviewed,
        },
        rcnContainer: {
            visible: isRCNAvailable && !hideRcnCta && showRcnMemo,
            openModalOnRender: loadRCNContainerNotShown(),
            openModal: showRcnMemo,
            policyPeriodData: policyWithRCN(accountPolicyData),
            hideRcnCta: setHideRcnCta
        },
        activePoliciesIterable: {
            data: policies.activePolicies,
            visible: policies.activePolicies.length > 0,
        },
        inactivePoliciesIterable: {
            data: policies.inactivePolicies,
            visible:policies.inactivePolicies.length > 0,
        },
        openClaimsTitle: {
            visible: areClaimsAvailable && openClaims.length > 0
        },
        openClaimsIterable: {
            data: openClaims,
            visible: areClaimsAvailable && openClaims.length > 0
        },
        closedClaimsTitle: {
            visible: areClaimsAvailable && closedClaims.length > 0
        },
        closedClaimsIterable: {
            data: closedClaims,
            visible: areClaimsAvailable && closedClaims.length > 0
        },
        activePoliciesTitle: {
            content: translator(messages.activePolicies),
            visible:policies.activePolicies.length > 0
        },
        inactivePoliciesTitle: {
            content: translator(messages.inactivePolicies),
            visible: policies.inactivePolicies.length > 0
        },
        pageTitle: {
            content: translator(messages.homeTitle)
        },
        bannerforActivePoliciesContainer: {
            visible:policies.activePolicies.length > 0
        },
        apbannerTitle: {
            content: WMICRichTextUtil.translateRichText(translator(messages.apBannerTitleTxt))
        },
        ...getTableOverrides()
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveValue: readValue,
        resolveComponentMap: {
            wmicOverduePolicies: WMICOverduePolicies,
            wmicRcn: WMICRcn,
            policySummaryBoxComponent: WMICPolicySummaryBoxAMP,
            claimSummaryBoxComponent: WMICClaimSummaryBoxAMP,
            wmicReviewContactInfo: WMICReviewContactInfo,
            WMICLoaderComponent: WMICLoader,
            WMICNoticesComponent: WMICNoticesComponent
        }
    };

    return <MetadataContent uiProps={metadata.pageContent} overrideProps={override} {...resolvers} />;
}

export default withRouter(LandingPage);
